// import React, { useState, useEffect, useRef } from "react";
// import config from "../../Common/Configurations/APIConfig";
// import apiService from "../../Common/Configurations/APIService";
// import Header from "../../Common/Layout/Header";
// import { useAuth } from "../../Common/Configurations/AuthContext";
// import { Link, useNavigate } from "react-router-dom";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faPlus, faMapMarkerAlt, faMoon, faEye, faPencilAlt, faTrashAlt, faSearch, faSyncAlt, faFilePdf } from '@fortawesome/free-solid-svg-icons';
// import DeleteAlert from "../../Common/Layout/DeleteAlert";
// import DMCPackageTab from "../../Components/AllTabs/DMCPackageTab";

// // Standard fallback if no image is uploaded
// const FALLBACK_IMAGE = "https://trawtelcdn.s3.eu-north-1.amazonaws.com/smarttravelcrm/package_images/default-package.jpg";

// const DMCPackageList = () => {
//     const { user, loading } = useAuth();
//     const navigate = useNavigate();
//     const [lists, setLists] = useState([]);
//     const [isLoading, setIsLoading] = useState(false);

//     // Search and Pagination States
//     const [searchTerm, setSearchTerm] = useState("");
//     const [appliedSearch, setAppliedSearch] = useState("");
//     const [pageNumber, setPageNumber] = useState(1);
//     const [totalPages, setTotalPages] = useState(0);
//     const [totalRecords, setTotalRecords] = useState(0);
//     const pageSize = 20;

//     const [showDeleteModal, setShowDeleteModal] = useState(false);
//     const [itemToDelete, setItemToDelete] = useState(null);
//     const isInitialMount = useRef(true);

//     const GetData = async (pageNum, currentSearch) => {
//         if (!user?.cid) return;
//         setIsLoading(true);
//         try {
//             let url = `${config.GETDMCPACKAGESBYCOMPANYID}?companyId=${user?.cid}&PageNumber=${pageNum}&PageSize=${pageSize}`;
//             if (currentSearch) url += `&search=${encodeURIComponent(currentSearch)}`;

//             const res = await apiService.getAll(url);
//             console.log("Fetched DMC Packages:", res);
//             setLists(res.data || []);
//             setTotalPages(res.totalPages || 0);
//             setTotalRecords(res.totalRecords || 0);
//             setPageNumber(res.pageNumber || 1);
//         } catch (error) {
//             console.error("Error fetching DMC packages:", error);
//             setLists([]);
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     useEffect(() => {
//         if (!loading && !user) { navigate("/"); return; }
//         if (user) {
//             if (isInitialMount.current) {
//                 isInitialMount.current = false;
//                 GetData(1, "");
//             } else {
//                 GetData(pageNumber, appliedSearch);
//             }
//         }
//     }, [user, loading, pageNumber]);

//     const handleSearch = () => {
//         setAppliedSearch(searchTerm);
//         setPageNumber(1);
//         GetData(1, searchTerm);
//     };

//     const handleReset = () => {
//         setSearchTerm("");
//         setAppliedSearch("");
//         setPageNumber(1);
//         GetData(1, "");
//     };

//     const handleKeyPress = (e) => { if (e.key === 'Enter') handleSearch(); };

//     const handleDelete = async () => {
//         if (itemToDelete) {
//             try {
//                 const idWithQuery = `${itemToDelete}?CompanyId=${user?.cid}`;
//                 await apiService.remove(config.DELETEDMCPACKAGE, idWithQuery);
//                 GetData(pageNumber, appliedSearch);
//             } catch (error) { console.error("Error deleting package:", error); }
//             setShowDeleteModal(false);
//         }
//     };

//     const renderPageNumbers = () => {
//         const pages = [];
//         for (let i = 1; i <= totalPages; i++) {
//             pages.push(
//                 <li key={i} className={`page-item ${pageNumber === i ? "active" : ""}`} onClick={() => setPageNumber(i)}>
//                     <button className="page-link">{i}</button>
//                 </li>
//             );
//         }
//         return pages;
//     };

//     if (loading) return <div className="p-5 text-center">Loading...</div>;

//     return (
//         <div className="layout-wrapper">
//             <Header User={user} activeSection={"holidays"}/>
//             <div className="p-2"><DMCPackageTab pageName="DMCPACKAGESLIST" /></div>
            
//             <div className="holidaydashboard-dashboard">
//                 <div className="holidaydashboard-content-wrapper">
//                     <div className="container-fluid">
//                         <div className="card shadow-sm border-0" style={{ borderRadius: '12px' }}>
//                             <div className="card-body">
//                                 {/* SEARCH UI */}
//                                 <div className="row g-3 mb-4 align-items-center">
//                                     <div className="col-md-4">
//                                         <div className="input-group shadow-sm border border-dark rounded">
//                                             <span className="input-group-text bg-white border-0">
//                                                 <FontAwesomeIcon icon={faSearch} className="text-muted" />
//                                             </span>
//                                             <input
//                                                 type="text"
//                                                 className="form-control border-0"
//                                                 placeholder="Search packages..."
//                                                 value={searchTerm}
//                                                 onChange={(e) => setSearchTerm(e.target.value)}
//                                                 onKeyDown={handleKeyPress}
//                                             />
//                                         </div>
//                                     </div>
//                                     <div className="col-md-4">
//                                         <button className="btn btn-primary me-2 px-4" onClick={handleSearch}>Search</button>
//                                         <button className="btn btn-danger px-4" onClick={handleReset}>Reset</button>
//                                     </div>
//                                     <div className="col-md-4 text-end">
//                                         <Link to="/dmcpackagecreate" className="btn btn-primary">
//                                             <FontAwesomeIcon icon={faPlus} /> Create New Package
//                                         </Link>
//                                     </div>
//                                 </div>

//                                 {isLoading ? (
//                                     <div className="text-center py-5">
//                                         <div className="spinner-border text-primary" role="status"></div>
//                                     </div>
//                                 ) : (
//                                     <>
//                                         <div className="row">
//                                             {lists.length > 0 ? (
//                                                 lists.map((pkg) => {
//                                                     // --- NEW IMAGE LOGIC ---
//                                                     // Check if backend returned images in the media object
//                                                     const hasImage = pkg.media?.images && pkg.media.images.length > 0;
//                                                     const displayImage = hasImage ? pkg.media.images[0].url : FALLBACK_IMAGE;

//                                                     return (
//                                                         <div key={pkg.id} className="col-xl-3 col-md-6 mb-4">
//                                                             <div className="card h-100 shadow-sm border-0" style={{ borderRadius: "12px", overflow: "hidden" }}>
//                                                                 <div style={{ height: "160px", position: "relative", background: "#f8f9fa" }}>
//                                                                     <img
//                                                                         src={displayImage}
//                                                                         alt={pkg.title}
//                                                                         style={{ width: "100%", height: "100%", objectFit: "cover" }}
//                                                                         onError={(e) => { e.currentTarget.src = FALLBACK_IMAGE; }}
//                                                                     />
                                                                    
//                                                                     {/* PDF Badge if it's a PDF-only package */}
//                                                                     {pkg.contentType === 2 && (
//                                                                         <div style={{ position: "absolute", top: "10px", left: "10px", background: "#ef4444", color: "#fff", padding: "2px 8px", borderRadius: "4px", fontSize: "10px", fontWeight: "bold" }}>
//                                                                             <FontAwesomeIcon icon={faFilePdf} /> PDF FLYER
//                                                                         </div>
//                                                                     )}

//                                                                     <div style={{ position: "absolute", top: "10px", right: "10px", background: "rgba(0,0,0,0.7)", color: "#fff", padding: "3px 10px", borderRadius: "20px", fontSize: "11px", fontWeight: "bold" }}>
//                                                                         <FontAwesomeIcon icon={faMoon} /> {pkg.totalNights}N / {pkg.totalDays}D
//                                                                     </div>
//                                                                 </div>

//                                                                 <div className="card-body p-3">
//                                                                     <div className="text-primary small fw-bold mb-1 text-truncate">
//                                                                         <FontAwesomeIcon icon={faMapMarkerAlt} /> {pkg.destinations?.[0]?.countryName || "DMC Deal"}
//                                                                     </div>

//                                                                     <h5 className="card-title mb-3 text-truncate" title={pkg.title} style={{ fontSize: "15px", fontWeight: "800" }}>
//                                                                         {pkg.title}
//                                                                     </h5>

//                                                                     <div className="d-flex justify-content-between align-items-center mb-3">
//                                                                         <div>
//                                                                             <div className="text-muted small" style={{ fontSize: "10px" }}>STARTING AT</div>
//                                                                             <div className="text-dark fw-bold" style={{ fontSize: "15px" }}>
//                                                                                 {pkg.pricing?.currency || 'INR'} {pkg.pricing?.landOnly?.double?.toLocaleString() || '0'}
//                                                                             </div>
//                                                                         </div>
//                                                                         <span className={`badge ${pkg.status === 0 ? "bg-soft-warning text-warning" : "bg-soft-success text-success"}`}>
//                                                                             {pkg.status === 0 ? "Draft" : "Active"}
//                                                                         </span>
//                                                                     </div>

//                                                                     <div className="d-flex gap-2 border-top pt-3">
//                                                                         <Link to={`/dmcpackageview/${pkg.id}`} className="btn btn-sm btn-info flex-fill">
//                                                                             <FontAwesomeIcon icon={faEye} /> View
//                                                                         </Link>
//                                                                         <Link 
//                                                                             to={pkg.contentType === 2 ? `/dmccreate-pdf?id=${pkg.id}` : `/dmcpackagecreate?id=${pkg.id}`} 
//                                                                             className="btn btn-sm btn-primary flex-fill"
//                                                                         >
//                                                                             <FontAwesomeIcon icon={faPencilAlt} /> Edit
//                                                                         </Link>
//                                                                         <button className="btn btn-sm btn-danger" onClick={() => { setItemToDelete(pkg.id); setShowDeleteModal(true); }}>
//                                                                             <FontAwesomeIcon icon={faTrashAlt} />
//                                                                         </button>
//                                                                     </div>
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                     );
//                                                 })
//                                             ) : (
//                                                 <div className="text-center py-5 w-100">
//                                                     <h5 className="text-muted">No packages found</h5>
//                                                 </div>
//                                             )}
//                                         </div>

//                                         {/* Pagination */}
//                                         {lists.length > 0 && (
//                                             <div className="d-flex justify-content-between align-items-center mt-4">
//                                                 <div className="text-muted small">
//                                                     Showing <span className="fw-bold">{lists.length}</span> of <span className="fw-bold">{totalRecords}</span> Results
//                                                 </div>
//                                                 <ul className="pagination pagination-separated mb-0">
//                                                     <li className={`page-item ${pageNumber === 1 ? "disabled" : ""}`} onClick={() => setPageNumber(p => Math.max(1, p - 1))}>
//                                                         <button className="page-link">Previous</button>
//                                                     </li>
//                                                     {renderPageNumbers()}
//                                                     <li className={`page-item ${pageNumber === totalPages ? "disabled" : ""}`} onClick={() => setPageNumber(p => Math.min(totalPages, p + 1))}>
//                                                         <button className="page-link">Next</button>
//                                                     </li>
//                                                 </ul>
//                                             </div>
//                                         )}
//                                     </>
//                                 )}
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             <DeleteAlert
//                 show={showDeleteModal}
//                 handleClose={() => setShowDeleteModal(false)}
//                 handleDelete={handleDelete}
//             />
//         </div>
//     );
// };

// export default DMCPackageList;

import React, { useState, useEffect, useRef } from "react";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faMapMarkerAlt, faMoon, faEye, faPencilAlt, faTrashAlt, faSearch, faSyncAlt, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import DeleteAlert from "../../Common/Layout/DeleteAlert";
// import DMCPackageTab from "../../Components/AllTabs/DMCPackageTab";

const FALLBACK_IMAGE = "https://trawtelcdn.s3.eu-north-1.amazonaws.com/smarttravelcrm/package_images/default-package.jpg";

const DMCPackageList = () => {
    const { user, loading } = useAuth();
    const navigate = useNavigate();
    const [lists, setLists] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const [searchTerm, setSearchTerm] = useState("");
    const [appliedSearch, setAppliedSearch] = useState("");
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);
    const pageSize = 20;

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);
    const isInitialMount = useRef(true);

    const GetData = async (pageNum, currentSearch) => {
        if (!user?.cid) return;
        setIsLoading(true);
        try {
            let url = `${config.GETDMCPACKAGESBYCOMPANYID}?companyId=${user?.cid}&PageNumber=${pageNum}&PageSize=${pageSize}`;
            if (currentSearch) url += `&search=${encodeURIComponent(currentSearch)}`;

            const res = await apiService.getAll(url);
            setLists(res.data || []);
            setTotalPages(res.totalPages || 0);
            setTotalRecords(res.totalRecords || 0);
            setPageNumber(res.pageNumber || 1);
        } catch (error) {
            console.error("Error fetching DMC packages:", error);
            setLists([]);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (!loading && !user) { navigate("/"); return; }
        if (user) {
            if (isInitialMount.current) {
                isInitialMount.current = false;
                GetData(1, "");
            } else {
                GetData(pageNumber, appliedSearch);
            }
        }
    }, [user, loading, pageNumber]);
    const handleToggleStatus = async (pkgId, currentStatus) => {
    // Logic: If currently Active (1), set to Inactive (2). 
    // If currently Draft (0) or Inactive (2), set to Active (1).
    const newStatus = currentStatus === 1 ? 2 : 1; 

    try {
        await apiService.put(`${config.UPDATEDMCPACKAGESTATUS}/${pkgId}/status?companyId=${user?.cid}&status=${newStatus}`);
        
        // Optimistic UI update: update the list locally
        setLists(prev => prev.map(pkg => 
            pkg.id === pkgId ? { ...pkg, status: newStatus } : pkg
        ));
    } catch (error) {
        console.error("Error updating status:", error);
    }
};

    const handleSearch = () => {
        setAppliedSearch(searchTerm);
        setPageNumber(1);
        GetData(1, searchTerm);
    };

    const handleReset = () => {
        setSearchTerm("");
        setAppliedSearch("");
        setPageNumber(1);
        GetData(1, "");
    };

    const handleKeyPress = (e) => { if (e.key === 'Enter') handleSearch(); };

    const handleDelete = async () => {
        if (itemToDelete) {
            try {
                const idWithQuery = `${itemToDelete}?CompanyId=${user?.cid}`;
                await apiService.remove(config.DELETEDMCPACKAGE, idWithQuery);
                GetData(pageNumber, appliedSearch);
            } catch (error) { console.error("Error deleting package:", error); }
            setShowDeleteModal(false);
        }
    };

    const renderPageNumbers = () => {
        const pages = [];
        for (let i = 1; i <= totalPages; i++) {
            pages.push(
                <li key={i} className={`page-item ${pageNumber === i ? "active" : ""}`} onClick={() => setPageNumber(i)}>
                    <button className="page-link">{i}</button>
                </li>
            );
        }
        return pages;
    };

    if (loading) return <div className="p-5 text-center">Loading...</div>;

    return (
        <div className="layout-wrapper">
            <Header User={user} activeSection={"holidays"}/>
            {/* <div className="p-2"><DMCPackageTab pageName="DMCPACKAGESLIST" /></div>
             */}
            <div className="holidaydashboard-dashboard">
                <div className="holidaydashboard-content-wrapper">
                    <div className="container-fluid">
                        <div className="card shadow-sm border-0" style={{ borderRadius: '12px' }}>
                            <div className="card-body">
                                <div className="row g-3 mb-4 align-items-center">
                                    <div className="col-md-4">
                                        <div className="input-group shadow-sm border border-dark rounded">
                                            <span className="input-group-text bg-white border-0">
                                                <FontAwesomeIcon icon={faSearch} className="text-muted" />
                                            </span>
                                            <input
                                                type="text"
                                                className="form-control border-0"
                                                placeholder="Search packages..."
                                                value={searchTerm}
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                                onKeyDown={handleKeyPress}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <button className="btn btn-primary me-2 px-4" onClick={handleSearch}>Search</button>
                                        <button className="btn btn-danger px-4" onClick={handleReset}>Reset</button>
                                    </div>
                                    <div className="col-md-4 text-end">
                                        <Link to="/dmcpackagecreate" className="btn btn-primary">
                                            <FontAwesomeIcon icon={faPlus} /> Create New Package
                                        </Link>
                                    </div>
                                </div>

                                {isLoading ? (
                                    <div className="text-center py-5">
                                        <div className="spinner-border text-primary" role="status"></div>
                                    </div>
                                ) : (
                                    <div className="row">
                                        {lists.length > 0 ? (
                                            lists.map((pkg) => {
                                                const hasImage = pkg.media?.images && pkg.media.images.length > 0;
                                                const displayImage = hasImage ? pkg.media.images[0].url : FALLBACK_IMAGE;

                                                // --- TASK 1: Join all country names ---
                                                const allDestinations = pkg.destinations?.length > 0 
                                                    ? pkg.destinations.map(d => d.countryName).join(", ") 
                                                    : "DMC Deal";

                                                return (
                                                    <div key={pkg.id} className="col-xl-3 col-md-6 mb-4">
                                                        <div className="card h-100 shadow-sm border-0" style={{ borderRadius: "12px", overflow: "hidden" }}>
                                                            <div style={{ height: "160px", position: "relative", background: "#f8f9fa" }}>
                                                                <img
                                                                    src={displayImage}
                                                                    alt={pkg.title}
                                                                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                                                    onError={(e) => { e.currentTarget.src = FALLBACK_IMAGE; }}
                                                                />
                                                                
                                                                {pkg.contentType === 2 && (
                                                                    <div style={{ position: "absolute", top: "10px", left: "10px", background: "#ef4444", color: "#fff", padding: "2px 8px", borderRadius: "4px", fontSize: "10px", fontWeight: "bold", zIndex: 1 }}>
                                                                        <FontAwesomeIcon icon={faFilePdf} /> PDF FLYER
                                                                    </div>
                                                                )}

                                                                {/* --- TASK 2: Hide Nights/Days badge for contentType 2 --- */}
                                                                {pkg.contentType !== 2 && (
                                                                    <div style={{ position: "absolute", top: "10px", right: "10px", background: "rgba(0,0,0,0.7)", color: "#fff", padding: "3px 10px", borderRadius: "20px", fontSize: "11px", fontWeight: "bold" }}>
                                                                        <FontAwesomeIcon icon={faMoon} /> {pkg.totalNights}N / {pkg.totalDays}D
                                                                    </div>
                                                                )}
                                                            </div>

                                                            <div className="card-body p-3">
                                                                {/* --- TASK 1: Displaying all destinations --- */}
                                                                <div className="text-primary small fw-bold mb-1 text-truncate" title={allDestinations}>
                                                                    <FontAwesomeIcon icon={faMapMarkerAlt} /> {allDestinations}
                                                                </div>

                                                                <h5 className="card-title mb-3 text-truncate" title={pkg.title} style={{ fontSize: "15px", fontWeight: "800" }}>
                                                                    {pkg.title}
                                                                </h5>

                                                                {/* --- TASK 2: Hide pricing section for contentType 2 --- */}
                                                                <div className="d-flex justify-content-between align-items-center mb-3">
    {pkg.contentType !== 2 ? (
        <div>
            <div className="text-muted small" style={{ fontSize: "10px" }}>STARTING AT</div>
            <div className="text-dark fw-bold" style={{ fontSize: "15px" }}>
                {pkg.pricing?.currency || 'INR'} {pkg.pricing?.landOnly?.double?.toLocaleString() || '0'}
            </div>
        </div>
    ) : (
        <div className="text-muted small italic">Flyer Package</div>
    )}

    {/* --- STATUS TOGGLE WITH PREFIXED CSS --- */}
    <div className="d-flex flex-column align-items-end">
        <div className="form-check form-switch dmc-pkg-status-switch mb-1">
            <input 
                className="form-check-input" 
                type="checkbox" 
                role="switch" 
                id={`switch-${pkg.id}`}
                checked={pkg.status === 1} 
                onChange={() => handleToggleStatus(pkg.id, pkg.status)}
                style={{ cursor: 'pointer' }}
            />
        </div>
        <span style={{ fontSize: '9px', fontWeight: '800', letterSpacing: '0.5px' }} 
              className={pkg.status === 1 ? "text-success" : (pkg.status === 0 ? "text-warning" : "text-secondary")}>
            {pkg.status === 1 ? "ACTIVE" : pkg.status === 0 ? "DRAFT" : "INACTIVE"}
        </span>
    </div>
</div>

                                                                <div className="d-flex gap-2 border-top pt-3">
                                                                    <Link to={`/dmcpackageview/${pkg.id}`} className="btn btn-sm btn-info flex-fill">
                                                                        <FontAwesomeIcon icon={faEye} /> View
                                                                    </Link>
                                                                    <Link 
                                                                        to={pkg.contentType === 2 ? `/dmccreate-pdf?id=${pkg.id}` : `/dmcpackagecreate?id=${pkg.id}`} 
                                                                        className="btn btn-sm btn-primary flex-fill"
                                                                    >
                                                                        <FontAwesomeIcon icon={faPencilAlt} /> Edit
                                                                    </Link>
                                                                    <button className="btn btn-sm btn-danger" onClick={() => { setItemToDelete(pkg.id); setShowDeleteModal(true); }}>
                                                                        <FontAwesomeIcon icon={faTrashAlt} />
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })
                                        ) : (
                                            <div className="text-center py-5 w-100">
                                                <h5 className="text-muted">No packages found</h5>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <DeleteAlert
                show={showDeleteModal}
                handleClose={() => setShowDeleteModal(false)}
                handleDelete={handleDelete}
            />
        </div>
    );
};

export default DMCPackageList;